import React from 'react';
import s3 from 'shared/constants/s3';
import { Row, Col } from 'bootstrap';
import MessageConstants from 'shared/constants/Messages';
import { teleprompter } from 'shared/constants/Onboarding';

export default React.createClass({
  displayName: 'TeleprompterActivation',

  render() {
    return (
      <div className="tele-activation">
        <Row>
          <Col md={24} className="tele-activation-img">
            <img src={s3.upgradeTeleprompter} />
          </Col>
          <Col md={24} className="tele-activation-title">
            {teleprompter.teleprompterWelcomeTitle}
          </Col>
          <Col md={24} className="tele-activation-desc">
            <p>{MessageConstants.upgradeTeleprompter}</p>
          </Col>
          <Col md={24} className="tele-activation-learn">
            <p>
              For more information and to request access,
              <a
                href="https://learn.shoflo.tv/teleprompter"
                rel="noopener noreferrer"
                target="_blank"
              >
                {' '}
                click here
              </a>
              .
            </p>
          </Col>
        </Row>
      </div>
    );
  },
});
